/**
 * Identity Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CcapTokenType = 'invalidToken' | 'shortAccessToken' | 'shortAccessToken3DCamera' | 'longAccessToken' | 'longAccessToken3DCamera' | 'lifeTimeToken' | 'lifeTimeToken3DCamera';

export const CcapTokenType = {
    InvalidToken: 'invalidToken' as CcapTokenType,
    ShortAccessToken: 'shortAccessToken' as CcapTokenType,
    ShortAccessToken3DCamera: 'shortAccessToken3DCamera' as CcapTokenType,
    LongAccessToken: 'longAccessToken' as CcapTokenType,
    LongAccessToken3DCamera: 'longAccessToken3DCamera' as CcapTokenType,
    LifeTimeToken: 'lifeTimeToken' as CcapTokenType,
    LifeTimeToken3DCamera: 'lifeTimeToken3DCamera' as CcapTokenType
};

